import Vue from 'vue';
import VueRouter from 'vue-router';

import commonRoutes from '@/common/router';
import store from '@/common/store';
import publicRoutes from '@/public/router';
import reviewerRoutes from '@/reviewer/router';
import adminRoutes from '@/admin/router';
import organisationRoutes from '@/organisation/router';

import { resetBreadcrumbs } from '@/common/utils/breadcrumbs';

Vue.use(VueRouter);

const routes = [
  ...adminRoutes,
  ...commonRoutes,
  ...publicRoutes,
  ...organisationRoutes,
  ...reviewerRoutes,
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  resetBreadcrumbs();
  if (localStorage.getItem('auth-token') !== null) {
    // There is an auth token stored in the local storage;
    if (!store.getters.user.isAuthenticated) {
      await store.dispatch('refreshUser');
      next();
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
